const metaAuth = {
  auth: 1,
  keepAlive: false,
};

export default [
  {
    path: "/yxzq01",
    name: "yxzq01",
    meta: metaAuth,
    component: () => import("@/views/basePcFour/index.vue"),
  },
];
